import React, { forwardRef } from 'react';

import ItemListingGrid from './ItemListingGrid';
import ItemListingRails from './ItemListingRails';
import { ItemListingCarouselProps, ItemListingProps } from './models';

const ItemListing = forwardRef<
  HTMLDivElement,
  ItemListingProps | ItemListingCarouselProps
>((itemListing, ref) => {
  // eslint-disable-next-line react/destructuring-assignment
  const type = 'type' in itemListing && itemListing.type;

  switch (type) {
    case 'numbered':
    case 'loadMore':
    case 'default':
      return (
        <ItemListingGrid ref={ref} {...(itemListing as ItemListingProps)} />
      );

    default:
      return (
        <ItemListingRails
          ref={ref}
          {...(itemListing as ItemListingCarouselProps)}
        />
      );
  }
});

export default ItemListing;
